import produce from "immer";
import { LoadState } from "../../constants/enums";
import { initialMasterForm, initialMasterFormsState } from "./defaultState";
import { IMasterFormsState } from "./masterForms.types";
import {
  FETCH_MASTER_FORM_LIST_PROGRESS,
  FETCH_MASTER_FORM_LIST_SUCCESS,
  FETCH_MASTER_FORM_LIST_FAILED,
  FETCH_MASTER_FORM_PROGRESS,
  FETCH_MASTER_FORM_SUCCESS,
  FETCH_MASTER_FORM_FAILED,
  CLEAR_MASTER_FORM_STATE,
  CLEAR_MASTER_FORM,
} from "./masterFormsActions";

export const masterFormsReducer = (
  state: IMasterFormsState = initialMasterFormsState,
  action: any
) => {
  switch (action.type) {
    // List Actions
    case FETCH_MASTER_FORM_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
    }

    case FETCH_MASTER_FORM_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = data;
        draftState.list.totalRecords = totalRecords;
        draftState.list.error = null;
      });
    }

    case FETCH_MASTER_FORM_LIST_FAILED: {
      const { errorMessage } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.error = errorMessage;
      });
    }

    // Single Form Actions
    case FETCH_MASTER_FORM_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.form.loading = LoadState.InProgress;
        draftState.form.data = initialMasterForm;
      });
    }

    case FETCH_MASTER_FORM_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.form.loading = LoadState.Loaded;
        draftState.form.data = data;
        draftState.form.error = null;
      });
    }

    case FETCH_MASTER_FORM_FAILED: {
      return produce(state, (draftState) => {
        draftState.form.loading = LoadState.Failed;
      });
    }

    case CLEAR_MASTER_FORM_STATE: {
      return produce(state, (draftState) => {
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
        draftState.list.loading = LoadState.NotLoaded;
      });
    }

    case CLEAR_MASTER_FORM: {
      return produce(state, (draftState) => {
        draftState.form.data = initialMasterForm;
        draftState.form.loading = LoadState.NotLoaded;
      });
    }

    default: {
      return state;
    }
  }
};
